import {useMemo} from "react";
import {useLocation} from "react-router-dom";

function useQuery() {
    const location = useLocation();


    return useMemo(() => {
        let toSearch: string = location.search

        //search in hash if needed
        if (location.hash.includes('?') && location.search === '') {
            //@ts-ignore
            toSearch = location.hash.split('?').pop().toString()
        }

        return Object.fromEntries(new URLSearchParams(toSearch))
    }, [location]);
}

export default useQuery
